export default {
    state: {
        flags: {}
    },

    getters: {
        anchorLinks (state) {
            return state.flags.anchorLinks
        }
    },

    mutations: {
        setFlag (state, { key, value }) {
            state.flags[key] = value
        },

        reset (state) {
            state.flags = {}
        }
    },

    namespaced: true
}
